import React from 'react';

import {UFBNoticeClickEvent} from '@udemy/browse-event-tracking';
import {Tracker} from '@udemy/event-tracking';
import {useMatchMedia} from '@udemy/hooks';
import {toBusinessUdemy} from '@udemy/organization';
import {SideDrawerProps} from '@udemy/react-dialog-components';

import {LoginSelectEvent} from 'src/events/header-events';

import {DesktopDemoFormHeader} from './desktop-demo-form-header.react-component';
import {MobileDemoFormHeader} from './mobile-demo-form-header.react-component';

export interface BaseDemoFormHeaderProps {
    logoButtonHref?: string;
    onLogoButtonClick?: () => void;
}

interface DemoFormHeaderLoginProps {
    dropdownPrimaryOnClick?: () => void;
    dropdownSecondaryOnClick?: () => void;
    primaryUrl?: string;
    secondaryUrl?: string;
    primaryUrlText?: string;
    secondaryUrlText?: string;
}

export interface DemoFormHeaderProps extends BaseDemoFormHeaderProps {
    loginProps?: DemoFormHeaderLoginProps;
}

export const DemoFormHeader = ({
    loginProps = {
        dropdownPrimaryOnClick: () => {
            Tracker.publishEvent(new LoginSelectEvent('ub_minimal_header_dropdown_org'));
        },
        dropdownSecondaryOnClick: () => {
            Tracker.publishEvent(new LoginSelectEvent('ub_minimal_header_dropdown_corpu'));
        },
        primaryUrl: 'https://www.udemy.com/organization/global-login/',
        secondaryUrl: 'https://open.corpu.com/',
        primaryUrlText: gettext('On-Demand Learning'),
        secondaryUrlText: gettext('Cohort Learning (Leadership Academy)'),
    },
}: DemoFormHeaderProps) => {
    const onLogoButtonClick = () => {
        Tracker.publishEvent(
            new UFBNoticeClickEvent({
                url: logoButtonHref,
                placement: 'ub_minimal_header',
            }),
        );
    };

    // These null checks are necessary because useMatchMedia returns null on the initial invocation of the hook
    // resulting in a flash of the desktop header on mobile device widths
    const isSmMax = useMatchMedia('sm-max');
    const showMobileHeader = isSmMax !== null && isSmMax;
    const showDesktopHeader = isSmMax !== null && !isSmMax;
    const sideDrawerProps: SideDrawerProps = {
        id: 'login-side-drawer',
        mainDrawerId: 'login-main-drawer',
        side: 'left',
        title: gettext('Log in'),
    };
    // Navigate users to UB landing page when logo clicked
    const logoButtonHref = toBusinessUdemy('', {placement: 'demo-form-header'});
    return (
        <>
            {showMobileHeader && (
                <div>
                    <MobileDemoFormHeader
                        data-testid="mobile-demo-form-header"
                        loginProps={loginProps}
                        sideDrawerProps={sideDrawerProps}
                        logoButtonHref={logoButtonHref}
                        onLogoButtonClick={onLogoButtonClick}
                    />
                </div>
            )}
            {showDesktopHeader && (
                <DesktopDemoFormHeader
                    data-testid="desktop-demo-form-header"
                    loginProps={loginProps}
                    logoButtonHref={logoButtonHref}
                    onLogoButtonClick={onLogoButtonClick}
                />
            )}
        </>
    );
};
